import { ChatCustomBlockTypes, type ChatMessage } from "@do/shared-types";

export const filterRasaCommand = (message: ChatMessage) =>
  !message.user ||
  !message.blocks ||
  message.blocks[0].type !== ChatCustomBlockTypes.text ||
  !message.blocks[0].text.match(/^\//);
